import classes from './Music.module.scss';
import Image from 'next/image';
import BadgeList from '../../molecules/badgeList/BadgeList';
import MusicCarousel from '../../organisms/musicCarousel/MusicCarousel';
import musicSettings from './config/carouselSettings.json';

const MusicSection = (props) => {
    if (!props) return null;

    const { 0: site_content, 1: site_image, 2: music_carousel } = props;
    const { music_features, tags_title } = props[3];

    return (
        <div className={classes.oMusic}>
            <div className={`${classes.oContainer} container`}>
                <div className={`row`}>
                    <div className={`${classes.oImageBlock} col-12 col-md-6`}>
                        <figure className={classes.mImage}>
                            <Image
                                src={site_image?.image?.data?.attributes.url}
                                alt={site_image?.image?.data?.attributes.title}
                                height={site_image?.image?.data?.attributes.height}
                                width={site_image?.image?.data?.attributes.width}
                                className={classes.aImage}
                                aria-hidden="true"
                                layout="responsive"
                            />
                        </figure>
                    </div>
                    <div className={`${classes.oBodyBlock} col-12 col-md-6`}>
                        <div className={`${classes.blockWrapper} fontRTL`}>
                            <h3 className={`${classes.aTitle} fnt30f`}>
                                {site_content.site_header}
                            </h3>
                            <div className={`${classes.aText} fnt18f fnt-pm`}>
                                <p>{site_content.site_description}</p>
                            </div>
                        </div>
                        <div className={classes.carouselWrapper}>
                            <MusicCarousel
                                config={musicSettings}
                                content={music_carousel.carousel_item}
                            />
                        </div>
                        <div className={classes.oBadgeWrapper}>
                            <BadgeList title={tags_title} data={music_features} />
                        </div>
                    </div>
                </div>
            </div>
            <figure className={classes.oBackground}>
                <svg
                    width="1346"
                    height="431"
                    viewBox="0 0 1346 431"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={classes.aSvgDesk}
                >
                    <path
                        d="M116 401.082C27 358.08 0.499569 281.579 0.49999 198.082C0.50049 98.8964 62.2843 31.7682 239 17.5795C415.717 3.39085 1314.25 -43.2621 1468.27 113.535C1567.9 214.953 1493.36 334.711 1434.07 406.489C1392.17 457.213 1391.08 389.701 1397.16 382.754C1365.3 373.195 1055.95 285.468 681.5 363.58C286 446.081 205 444.084 116 401.082Z"
                        fill="url(#paint0_linear_829_6917)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_829_6917"
                            x1="-248.289"
                            y1="294.485"
                            x2="871.702"
                            y2="294.485"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#EEC9FF" />
                            <stop offset="1" stopColor="#AD6BDF" />
                        </linearGradient>
                    </defs>
                </svg>
                <svg
                    width="360"
                    height="273"
                    viewBox="0 0 360 273"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={classes.aSvgMobile}
                    preserveAspectRatio="none"
                >
                    <path
                        d="M15.1148 254.432C-23.5018 227.153 -35.0002 178.624 -35 125.656C-34.9998 62.7364 -8.19219 20.1527 68.4838 11.1519C145.16 2.15115 535.026 -27.4438 601.857 72.0225C645.085 136.358 612.741 212.329 587.017 257.862C568.839 290.04 568.365 247.212 571.002 242.805C557.176 236.742 422.954 181.091 260.481 230.642C88.8766 282.978 53.7313 281.711 15.1148 254.432Z"
                        fill="url(#paint0_linear_1105_8755)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1105_8755"
                            x1="-142.948"
                            y1="186.811"
                            x2="343.009"
                            y2="186.811"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#EEC9FF" />
                            <stop offset="1" stopColor="#AD6BDF" />
                        </linearGradient>
                    </defs>
                </svg>
            </figure>
        </div>
    );
};

export default MusicSection;
